export function childAge(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  if (isNaN(d)) return "";
  const months = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24 * 30.44));
  const yrs = Math.floor(months / 12);
  if (yrs >= 1) return `${yrs} yr${yrs > 1 ? "s" : ""}`;
  return `${months} mo`;
}

export function childDays(days) {
  if (!days) return "";
  return String(days).split(",").map((d) => d.trim()).filter(Boolean).join(" / ");
}

export function dayList(days) {
  if (!days) return [];
  return String(days).split(",").map((d) => d.trim()).filter(Boolean);
}

export function formatDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}-${d.getFullYear()}`;
}

export function formatBirthDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return value;
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });
}

export const PHONE_DIGITS = 10;
export const MIN_PHONE_DIGITS = PHONE_DIGITS;
export const MAX_PHONE_DIGITS = PHONE_DIGITS;

/** Format up to 10 digits with spacing — any starting digit. */
export function formatPhone(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, PHONE_DIGITS);
  if (!digits) return "";
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
}

/** @deprecated use formatPhone */
export const formatAuMobile = formatPhone;

/** Digits only; empty allowed unless required; exactly 10 digits when provided. */
export function isValidPhone(value, { required = false } = {}) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return !required;
  return digits.length === PHONE_DIGITS;
}

/** @deprecated use isValidPhone */
export const isValidAuMobile = isValidPhone;
